<template>
    <div class="dashboard flex">
        <mobile-nav
            :open="mobileNavOpen"
        />
        <sidebar
            :has-notification="hasUserNotification"
            @open-mobile-nav="handleMobileNav"
        />
        <transition
            name="fade"
            mode="out-in"
        >
            <router-view />
        </transition>
        <transition-group
            name="fade"
            mode="out-in"
        >
            <!-- <onboarding v-if="UIState.isOnboardingModalVisible" key="onboardingModal" /> -->
            <upgrade-pro-modal v-if="UIState.isUpgradeProModalVisible" key="upgradeProModal" />
            <add-show-modal
                v-if="UIState.addShowModal.visible"
                key="addShowModal"
                :show-hash="UIState.addShowModal.hash"
            />
            <ShowModal v-if="showModalOpen" key="showModal" />
            <update-subscription-handler
                v-if="UIState.isBillingPlanChangeVisible"
                key="upgradeProModal"
                v-slot:default="{
                    isSubmitting,
                    isSubscriptionUpdated,
                    updateSubscription,
                }"
            >
                <billing-plan-change
                    :is-submitting="isSubmitting"
                    :is-subscription-updated="isSubscriptionUpdated"
                    @update-subscription="(subscriptionId, data) => updateSubscription(subscriptionId, data)"
                />
            </update-subscription-handler>
            <delete-show-modal
                v-if="UIState.deleteShowModal.visible"
                key="deleteShowModal"
            />
            <!-- TODO: rename to `show-hosting-upgrade-modal` -->
            <upgrade-show-modal
                v-if="UIState.upgradeShowModal.visible"
                key="upgradeShowModal"
                :show="UIState.upgradeShowModal.show"
                :add-ons="UIState.upgradeShowModal.addOns"
            />
            <show-hosting-downgrade-modal
                v-if="UIState.showHostingDowngradeModal.visible"
                key="showHostingDowngradeModal"
                :show="UIState.showHostingDowngradeModal.show"
            />
        </transition-group>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import overflowBlocker from '@/utils/overflowBlocker';
import { loadScript, removeScript } from '@/utils/scriptLoader';

import Sidebar from '@/components/Dashboard/Sidebar.vue';
import MobileNav from '@/components/Dashboard/MobileNavigation.vue';
// import Onboarding from '@/components/Dashboard/Onboarding.vue';
import BillingPlanChange from '@/components/Dashboard/Settings/Billing/BillingPlanChange.vue';
import AddShowModal from '@/components/Shows/AddShow/AddShowModal.vue';
import UpdateSubscriptionHandler from '@/components/Dashboard/Settings/Billing/UpdateSubscriptionHandler.vue';
import DeleteShowModal from '@/components/Shows/DeleteShow/DeleteShowModal';
import UpgradeShowModal from '@/components/Shows/UpgradeShow/UpgradeShowModal';
import ShowHostingDowngradeModal from '@/components/Shows/HostingDowngradeModal/Modal';
import { ShowModal } from '@/components';
import { ACTION } from '@/components/ShowModal/config';

export default {
    components: {
        // Onboarding,
        AddShowModal,
        BillingPlanChange,
        DeleteShowModal,
        MobileNav,
        ShowModal,
        ShowHostingDowngradeModal,
        Sidebar,
        UpdateSubscriptionHandler,
        UpgradeShowModal,
    },

    data: () => ({
        hideUserNotification: false,
        mobileNavOpen: false,
        upgradeShowHash: false,
        helpScountbeacon: {
            freeId: 'e0e1c51c-1192-47e3-b80d-c5bf6abee04d',
            proId: '7e4e98f9-1639-4f79-b25a-206e3af7f0d8',
        },
        hasUserNotification: false,
    }),

    computed: {
        ...mapState([
            'user',
            'UIState',
            'shows',
        ]),

        ...mapState('show/modal', {
            showModalOpen: state => state.modalOpen,
        }),
    },

    watch: {
        mobileNavOpen: {
            immediate: true,

            /**
             * Handles mobile menu value
             *
             * @param   {boolean}  newVal  New value from mobile btn.
             *
             */
            handler(newVal) {
                overflowBlocker(newVal);
            },
        },
    },

    /**
     * Mounted hook
     *
     */
    mounted() {
        this.newUserModals();

        loadScript('fast.wistia.com/assets/external/E-v1.js', 'wistia_embed', null);

        const app = document.getElementById('app');

        app.classList.add('full-height');

        this.loadHelpScout();

        // Set player embed variables
        window.FuseboxPlayerAPIKey = this.user.api_key?.key;
        window.FuseboxPlayerPreview = true;

        this.$once('hook:beforeDestroy', () => {
            app.classList.remove('full-height');
            removeScript('wistia_embed');
        });
    },

    /**
     * Before destroy hook
     *
     */
    beforeDestroy() {
        window.Beacon('destroy');
    },

    methods: {
        ...mapMutations(['changeUIState']),

        ...mapActions('show/modal', {
            openShowModal: 'openModal',
        }),

        ...mapMutations('show/modal', {
            setShowAction: 'setAction',
        }),

        /**
         * Handles mobile nav
         *
         * @param   {boolean}  value  True/false for mobile nav.
         *
         */
        handleMobileNav(value) {
            this.mobileNavOpen = value;
        },

        /**
         * Load Help Scout Beacon script
         *
         */
        loadHelpScout() {
            /* eslint-disable */
            !function(e,t,n){
                function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){}
                );
            /* eslint-enable */

            window.Beacon('init', this.helpScountbeacon.proId);
        },

        /**
         * Display new user modals
         */
        newUserModals() {
            const {
                has_shows,
                meta_data: {
                    hide_onboarding,
                    onboarding_finished,
                },
            } = this.user;

            if (! has_shows) {
                this.setShowAction(ACTION.CREATE);
                this.openShowModal();
                return;
            }

            if (
                ! this.user.suspended_at &&
                ! onboarding_finished &&
                ! hide_onboarding
            ) {
                // this.changeUIState({ isOnboardingModalVisible: true });
            }
        },
    },
};
</script>
